import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { addBanker, getBank, getProduct, getStateWiseCities, updateBanker } from "../../../services/userMasterUser";
import { pinCode } from "../../../components/Regex";
import { MultiSelect } from "primereact/multiselect";

export default function BankerCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [stateCitiesList, setStateCitiesList] = useState([])
  const [stateCityList, setStateCityList] = useState({});

  const [bankList, setBankList] = useState([]);
  const [productDataList, setProductDataList] = useState([]);
  const [input, setInput] = useState({

    bankId: state?.bank?.id || "",
    nameOfBanker: state?.nameOfBanker || "",
    mobile: state?.mobile || "",
    bankerEmailId: state?.bankerEmailId || "",
    designation: state?.designation || "",
    bankPolicy: state?.bankPolicy || "",
    address: state?.address || "",
    city: state?.city || "",
    pinCode: state?.pinCode || "",
    state: state?.state || "",
    branchCategory: state?.branchCategory || "",
    // productList: state?.productList || "",
    productIds: state?.productIds || "",
    minimumLoanAmount: state?.minimumLoanAmount || "",
    maximumLoanAmount: state?.maximumLoanAmount || "",
    levelOfDepartmentSalesMinimum: state?.levelOfDepartmentSalesMinimum || "",
    levelOfDepartmentSalesMaximum: state?.levelOfDepartmentSalesMaximum || "",
  });

  const citiesList = stateCityList[input.state] || [];

  const branchCategoryDataList = [
    { label: "Normal", value: "Normal" },
    { label: "Agri", value: "Agri"},
    { label: "MSME", value: "MSME"},
    { label: "Mid-Corporate", value: "Mid-Corporate"},
    { label: "Large-Corporate", value: "Large-Corporate"},
  ]

  useEffect(() => {

    getBank()
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const bank = Res.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setBankList(bank)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));

    const typeProductData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      statusIn: []
    };

    getProduct(typeProductData)
      .then((response) => {
        if (!response.data.error) {
          const newData = response.data.data || response.data; // adjust if API structure differs
          const productData = newData.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setProductDataList(productData);
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch(() => {
        errorMessage();
      })

    const stateCitiesData = {
      searchBy: "",
      searchText: "",
      limit: 100000,
      offset: 0,
      sortBy: "",
      sortOrder: "desc",
      cityIn: [],
      stateIn: []
    }

    getStateWiseCities(stateCitiesData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          // const stateList = Object.keys(Res).map((key) => ({
          //   key
          // }));

          const stateListArray = Object.keys(Res);

          const stateList = stateListArray.map((item) => ({
            label: item,
            value: item,
          }));

          setStateCitiesList(stateList)

          setStateCityList(Res)
        } else {
          errorMessage("Invalid Credentials");
        }
      })
      .catch((err) => {
        errorMessage();
      })
      .finally(() => console.log(false));


    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  const [errors, setErrors] = useState({
    nameOfBanker: "",
    mobile: "",
    bankerEmailId: "",
    designation: "",
    bankPolicy: "",
    pinCode:"",
    city:"",
    state:"",
    address: "",
    branchCategory: "",
    // productList: "",
    productIds: "",
    minimumLoanAmount: "",
    maximumLoanAmount: "",
    levelOfDepartmentSalesMinimum: "",
    levelOfDepartmentSalesMaximum: "",
  });

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;

    if (!(input.nameOfBanker)) {
      newErrors.nameOfBanker = "Please Enter Name Of Banker";
      isValid = false;
    } else {
      newErrors.nameOfBanker = "";
    }

    if (!(input.mobile)) {
      newErrors.mobile = "Please Enter Mobile";
      isValid = false;
    } else {
      newErrors.mobile = "";
    }


    if (!(input.bankerEmailId)) {
      newErrors.bankerEmailId = "Please Enter Banker Email Id";
      isValid = false;
    } else {
      newErrors.bankerEmailId = "";
    }

    if (!(input.designation)) {
      newErrors.designation = "Please Enter Designation";
      isValid = false;
    } else {
      newErrors.designation = "";
    }

    if (!(input.bankPolicy)) {
      newErrors.bankPolicy = "Please Enter Bank Policy";
      isValid = false;
    } else {
      newErrors.bankPolicy = "";
    }

    if (!(input.pinCode)) {
      newErrors.pinCode = "Please Enter Pin Code";
      isValid = false;
    } else {
      newErrors.pinCode = "";
    }

    
    if (!(input.branchCategory)) {
      newErrors.branchCategory = "Please Enter Branch Category";
      isValid = false;
    } else {
      newErrors.branchCategory = "";
    }

    if (!(input.state)) {
      newErrors.state = "Please Enter State";
      isValid = false;
    } else {
      newErrors.state = "";
    }

    if (!(input.city)) {
      newErrors.city = "Please Enter City";
      isValid = false;
    } else {
      newErrors.city = "";
    }
   

    if (!(input.address)) {
      newErrors.address = "Please Enter Address";
      isValid = false;
    } else {
      newErrors.address = "";
    }

    if (!(input.productIds)) {
      newErrors.productIds = "Please Enter Product Ids";
      isValid = false;
    } else {
      newErrors.productIds = "";
    }

    if (!(input.minimumLoanAmount)) {
      newErrors.minimumLoanAmount = "Please Enter Minimum Loan Amount";
      isValid = false;
    } else {
      newErrors.minimumLoanAmount = "";
    }

    if (!(input.maximumLoanAmount)) {
      newErrors.maximumLoanAmount = "Please Enter Maximum Loan Amount";
      isValid = false;
    } else {
      newErrors.maximumLoanAmount = "";
    }

    if (!(input.levelOfDepartmentSalesMinimum)) {
      newErrors.levelOfDepartmentSalesMinimum = "Please Enter Level Of Department Sales Minimum";
      isValid = false;
    } else {
      newErrors.levelOfDepartmentSalesMinimum = "";
    }

    if (!(input.levelOfDepartmentSalesMaximum)) {
      newErrors.levelOfDepartmentSalesMaximum = "Please Enter Level Of Department Sales Maximum";
      isValid = false;
    } else {
      newErrors.levelOfDepartmentSalesMaximum = "";
    }


    if (input.status === "") {
      newErrors.status = "Please Choose Status";
      isValid = false;
    } else {
      newErrors.status = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          bank: {
            id: input.bankId
          },
          bankerEmailId: input.bankerEmailId,
          nameOfBanker: input.nameOfBanker,
          mobile: input.mobile,
          designation: input.designation,
          bankPolicy: input.bankPolicy,
          city: input.city,
          pinCode: input.pinCode,
          state: input.state,
          address: input.address,
          branchCategory: input.branchCategory,
          // productList: input.productList,
          productIds: input.productIds,
          minimumLoanAmount: input.minimumLoanAmount,
          maximumLoanAmount: input.maximumLoanAmount,
          levelOfDepartmentSalesMinimum: input.levelOfDepartmentSalesMinimum,
          levelOfDepartmentSalesMaximum: input.levelOfDepartmentSalesMaximum,
          status: input.status,
        };
        updateBanker(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/Banker/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          bank: {
            id: input.bankId
          },
          bankerEmailId: input.bankerEmailId,
          nameOfBanker: input.nameOfBanker,
          mobile: input.mobile,
          designation: input.designation,
          bankPolicy: input.bankPolicy,
          address: input.address,
          city: input.city,
          pinCode: input.pinCode,
          state: input.state,
          branchCategory: input.branchCategory,
          // productList: input.productList,
          productIds: input.productIds,
          minimumLoanAmount: input.minimumLoanAmount,
          maximumLoanAmount: input.maximumLoanAmount,
          levelOfDepartmentSalesMinimum: input.levelOfDepartmentSalesMinimum,
          levelOfDepartmentSalesMaximum: input.levelOfDepartmentSalesMaximum

        };
        addBanker(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/Banker/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/banker/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> Banker {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Name Of Banker
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="nameOfBanker"
                        name="nameOfBanker"
                        value={input.nameOfBanker}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            nameOfBanker: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.nameOfBanker}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Bank List
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={bankList}
                        value={input.bankId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            bankId: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.bankId}</div>
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Mobile
                      </label>
                      <InputText
                        type="tel"
                        style={{ width: "100%" }}
                        id="mobile"
                        name="mobile"
                        value={input.mobile}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            mobile: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.mobile}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Banker Email Id
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="bankerEmailId"
                        name="bankerEmailId"
                        value={input.bankerEmailId}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            bankerEmailId: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.bankerEmailId}</div>
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Designation
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="designation"
                        name="designation"
                        value={input.designation}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            designation: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.designation}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Bank Policy
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="bankPolicy"
                        name="bankPolicy"
                        value={input.bankPolicy}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            bankPolicy: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.bankPolicy}</div>
                    </div>

                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Address
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="address"
                        name="address"
                        value={input.address}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            address: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.address}</div>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">State</label>
                        <Dropdown
                          style={{ width: "100%" }}
                          value={input.state}
                          onChange={(e) =>
                            setInput({ ...input, state: e.target.value })
                          }
                          options={stateCitiesList}
                          optionLabel="label"
                          placeholder="Select a State"
                          filter
                          filterDelay={400}
                        />
                        <div className="text-danger">{errors.state}</div>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Pin Code </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        value={input.pinCode}
                        onChange={(e) =>
                          setInput({ ...input, pinCode: e.target.value })
                        }
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // prevent arrow increment/decrement
                          }
                        }}
                      />
                      <div className="text-danger">{errors.pinCode}</div>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">City</label>
                      <Dropdown
                        style={{ width: "100%" }}
                        value={input.city}
                        onChange={(e) =>
                          setInput({ ...input, city: e.target.value })
                        }
                        options={citiesList}

                        placeholder="Select a City"
                        filter
                        filterDelay={400}
                      />
                      <div className="text-danger">{errors.city}</div>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Product
                      </label>
                      {/*<Dropdown
                        style={{ width: "100%" }}
                        options={productDataList}
                        value={input.productIds}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            productIds: e.value,
                          });
                        }}
                      />*/}
                      <MultiSelect
                        style={{ width: "100%" }}
                        value={input.productIds}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            productIds: e.value,
                          });
                        }}
                        options={productDataList}
                        optionLabel="label"
                        placeholder="Select Product"
                      />
                      <div className="text-danger">{errors.productIds}</div>
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Branch Category
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={branchCategoryDataList}
                        value={input.branchCategory}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            branchCategory: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.branchCategory}</div>
                    </div>

                 
                    
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Minimum Loan Amount (In Lacs)
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="minimumLoanAmount"
                        name="minimumLoanAmount"
                        value={input.minimumLoanAmount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            minimumLoanAmount: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.minimumLoanAmount}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Maximum Loan Amount (In Lacs)
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="maximumLoanAmount"
                        name="maximumLoanAmount"
                        value={input.maximumLoanAmount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            maximumLoanAmount: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.maximumLoanAmount}</div>
                    </div>

                  
                    
                  </div>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Level Of Department Sales Minimum
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="levelOfDepartmentSalesMinimum"
                        name="levelOfDepartmentSalesMinimum"
                        value={input.levelOfDepartmentSalesMinimum}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            levelOfDepartmentSalesMinimum: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.levelOfDepartmentSalesMinimum}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Level Of Department Sales Maximum
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="levelOfDepartmentSalesMaximum"
                        name="levelOfDepartmentSalesMaximum"
                        value={input.levelOfDepartmentSalesMaximum}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            levelOfDepartmentSalesMaximum: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.levelOfDepartmentSalesMaximum}</div>
                    </div>
                  </div>


                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
